export default __webpack_public_path__ + "static/char-s-43-zh-Hans-70893c0e59ce414a5e5b0ee9ee9fd6d5.webp";